<div class="fixed top-0 left-0 w-screen h-screen flex items-center justify-center">
    <div class="h-32 w-32 animate-spin border-[6px] border-t-[#2D2D2D]  rounded-full">
        <!-- <img  class="h-32 w-32" src="https://www.ifood.it/wp-content/uploads/2023/11/giorgione.jpg"> Giorgione test -->
    </div>
</div>